//@ts-nocheck
import React, { useState } from "react";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import { ChevronDownIcon, CrossIcon } from "../icons/Icons";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  fetchApplicationByDetails,
  UpdateJobApplicationByListForApplication,
} from "../../features/ApplicationData/ApplicationDataSlice";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  Switch,
  Transition,
} from "@headlessui/react";
import JobWorkplaceTypeListbox from "./JobWorkplaceTypeListbox";
import JobEduLocationModal from "./JobEduLocationModal";
import { getColorForLabel } from "../../utils/colorUtils";
import { toast } from "sonner";

const CustomDropdown = ({
  label,
  value,
  onChange,
  options,
  name,
  placeholder = "Select...",
}) => {
  const selectedOption = options.find((opt) => opt.value === value);

  const handleChange = (newValue) => {
    // Simulate an event object that matches the expected structure
    onChange({
      target: {
        name: name,
        value: newValue,
      },
    });
  };

  return (
    <div className="grid gap-[6px]">
      {label && (
        <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
          {label}
        </label>
      )}
      <Listbox value={value} onChange={handleChange}>
        <div className="relative">
          <Listbox.Button className="relative w-full cursor-pointer rounded-lg bg-white py-[5px] pl-3 pr-10 text-left border border-gray-200 focus:outline-none focus-visible:border-indigo-500 focus-visible:ring-2 focus-visible:ring-white/75 focus-visible:ring-offset-2">
            <span
              className={`block truncate text-[14px] ${!selectedOption ? "text-gray-400" : "text-gray-900"}`}
            >
              {selectedOption ? selectedOption.label : placeholder}
            </span>
            <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
              <ChevronDownIcon
                className="h-5 w-5 text-gray-400"
                aria-hidden="true"
              />
            </span>
          </Listbox.Button>
          <Transition
            as={React.Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Listbox.Options className="absolute overflow-auto h-[150px] z-10 mt-[9px] left-[0px] bg-white max-w-[100%] min-w-[100%] w-full rounded-lg border border-border bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
              {options.map((option) => (
                <Listbox.Option
                  key={option.value}
                  value={option.value}
                  className={({ active, selected }) =>
                    `relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 ${active ? "bg-gray-200 text-[#1d2025]" : "text-gray-900"}`
                  }
                >
                  {({ selected }) => (
                    <span
                      className={`block truncate text-[14px] ${selected ? "font-medium" : "font-normal"}`}
                    >
                      {option.label}
                    </span>
                  )}
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Transition>
        </div>
      </Listbox>
    </div>
  );
};

const JobExperienceSection = ({
  experienceData,
  onUpdate,
  setapplicationDetails,
  isConductReview,
  applicationIdByParent,
}: any) => {
  const [selectedEducation, setSelectedEducation] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [workplaceType, setWorkplaceType] = useState("");
  const locations = useAppSelector((state) => state.location.locationDetails);
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [openDeleteModalExp, setOpenDeleteModalExp] = useState(false);
  const [deleteLoadingExp, setDeleteLoadingExp] = useState(false);
  const [workExperienceData, setWorkExperienceData] = useState(experienceData);
  const handleWorkplaceTypeChange = (value) => {
    setWorkplaceType(value);
    setEditForm((prev) => ({
      ...prev,
      workplaceType: value,
    }));
  };

  const [editForm, setEditForm] = useState({
    company: "",
    designation: "",
    startDateMonth: "",
    startDateYear: "",
    endDateMonth: "",
    endDateYear: "",
    location: "",
    workplaceType: "",
    isCurrentJob: false,
    description: "",
  });

  const { baseId, jobId, applicationId } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
  }>();
  const dispatch = useAppDispatch();

  const parseWorkExperience = (workString: any) => {
    try {
      const parsedData = JSON.parse(workString);
      // Ensure work_experience is an array and filter out null values
      return {
        ...parsedData,
        work_experience:
          parsedData.work_experience?.filter((work) => work !== null) || [],
      };
    } catch (e) {
      console.error("Error parsing work experience data:", e);
      return { work_experience: [] };
    }
  };

  // Split the date string to extract month and year
  const splitDate = (dateString) => {
    if (!dateString) return { month: "", year: "" };

    // Check if the format is already separated
    if (typeof dateString === "object" && dateString.month && dateString.year) {
      return dateString;
    }

    // Try to parse as a string
    const parts = dateString.toString().split(" ");
    if (parts.length === 2) {
      // Convert month name to number
      const monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthIndex = monthNames.indexOf(parts[0]);
      const month =
        monthIndex >= 0 ? (monthIndex + 1).toString().padStart(2, "0") : "";
      return { month, year: parts[1] };
    }

    return { month: "", year: "" };
  };

  const workExperience = parseWorkExperience(experienceData);

  const handleEditClick = (work, index) => {
    // isConductReview is a boolean prop that determines if the user is a reviewer
    if (isConductReview) return;
    setSelectedExperience(work);
    setSelectedIndex(index);

    // Check all possible property names for start/end dates
    const startMonth =
      work.startDateMonth ||
      work.start_month ||
      (work.start_date && typeof work.start_date === "object"
        ? work.start_date.month
        : "");
    const startYear =
      work.startDateYear ||
      work.start_year ||
      (work.start_date && typeof work.start_date === "object"
        ? work.start_date.year
        : "");
    const endMonth =
      work.endDateMonth ||
      work.end_month ||
      (work.end_date && typeof work.end_date === "object"
        ? work.end_date.month
        : "");
    const endYear =
      work.endDateYear ||
      work.end_year ||
      (work.end_date && typeof work.end_date === "object"
        ? work.end_date.year
        : "");

    setEditForm({
      company: work.company || "",
      designation: work.designation || "",
      startDateMonth: startMonth,
      startDateYear: startYear,
      endDateMonth: endMonth,
      endDateYear: endYear,
      location: work.location || "",
      workplaceType: work.workplace_type || "",
      isCurrentJob: work.isCurrentJob === "true",
      description: work.description || "",
    });
    setWorkplaceType(work.workplace_type || "");
    setSelectedCountry(work.location);
    setSelectedEducation(work);

    setIsModalOpen(true);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      if (!editForm.company || editForm.company.trim() === "") {
        toast.error("Company is required");
        setIsLoading(false);
        return;
      }
      if (!editForm.designation || editForm.designation.trim() === "") {
        toast.error("Designation is required");
        setIsLoading(false);
        return;
      }
      // Create a copy of the original work experience object
      const updatedWorkExperience = { ...workExperience };

      // Create updated work experience array
      const updatedWorkExperienceDetails = [...workExperience.work_experience];

      // Update the specific work entry
      updatedWorkExperienceDetails[selectedIndex] = {
        ...selectedExperience,
        company: editForm.company,
        designation: editForm.designation,
        startDateMonth: editForm.startDateMonth,
        startDateYear: editForm.startDateYear,
        endDateMonth: editForm.endDateMonth,
        endDateYear: editForm.endDateYear,
        location: editForm.location,
        workplace_type: editForm.workplaceType,
        isCurrentJob: editForm.isCurrentJob.toString(),
        description: editForm.description,
      };

      // Update the work_experience in the copied object
      updatedWorkExperience.work_experience = updatedWorkExperienceDetails;
      const payload = {
        baseId,
        applicationId: applicationId ? applicationId : applicationIdByParent,
        app_work: JSON.stringify(updatedWorkExperience),
      };

      const response = await dispatch(
        UpdateJobApplicationByListForApplication(payload),
      ).unwrap();

      if (response) {
        const res = await dispatch(
          fetchApplicationByDetails({
            baseId: Number(baseId),
            jobId: jobId,
            applicationId: applicationId
              ? applicationId
              : applicationIdByParent,
          }),
        ).unwrap();
        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }
        if (onUpdate) {
          onUpdate(updatedWorkExperience);
        }
        setIsModalOpen(false);
      }
    } catch (error) {
      console.error("Failed to update work experience:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleLocationChange = (item) => {
    // Update the selected country state
    setSelectedCountry(item);

    // Update the location field in the editForm state
    setEditForm((prev) => ({
      ...prev,
      location: item.locationName, // Assuming the location object has a 'locationName' property
    }));
  };

  // Month options with text labels
  const months = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const years = Array.from({ length: 30 }, (_, i) => {
    const year = (2025 - i).toString();
    return { value: year, label: year };
  });

  // Convert numeric month to text representation
  const getMonthName = (monthNumber) => {
    if (!monthNumber) return "";
    const monthIndex = parseInt(monthNumber, 10) - 1;
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    return monthNames[monthIndex] || "";
  };

  // Format month and year for display
  const formatMonthYear = (month, year) => {
    if (!month || !year) return "";
    const monthName = getMonthName(month);
    return `${monthName} ${year}`;
  };

  const formatDate = (month, year) => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const monthIndex = parseInt(month, 10) - 1;
    return monthNames[monthIndex] ? `${monthNames[monthIndex]} ${year}` : year;
  };

  const formatDateRange = (work) => {
    // Check all possible property names for start date
    const startMonthValue =
      work.startDateMonth ||
      work.start_month ||
      (work.start_date && typeof work.start_date === "object"
        ? work.start_date.month
        : "");
    const startYearValue =
      work.startDateYear ||
      work.start_year ||
      (work.start_date && typeof work.start_date === "object"
        ? work.start_date.year
        : "");

    // Check all possible property names for end date
    const endMonthValue =
      work.endDateMonth ||
      work.end_month ||
      (work.end_date && typeof work.end_date === "object"
        ? work.end_date.month
        : "");
    const endYearValue =
      work.endDateYear ||
      work.end_year ||
      (work.end_date && typeof work.end_date === "object"
        ? work.end_date.year
        : "");

    const startMonthName = getMonthName(startMonthValue);
    const formattedStartDate =
      startMonthName && startYearValue
        ? `${startMonthName} ${startYearValue}`
        : "";

    const endMonthName = getMonthName(endMonthValue);
    const formattedEndDate =
      endMonthName && endYearValue
        ? `${endMonthName} ${endYearValue}`
        : endYearValue || "";

    return formattedStartDate && formattedEndDate
      ? `${formattedStartDate} - ${formattedEndDate}`
      : "";
  };

  const handleDeleteClick = (work, index) => {
    setSelectedIndex(index); // Store the index to be deleted
    setOpenDeleteModalExp(true); // Open the confirmation modal
  };

  // Function to handle cancel button in delete modal
  const handleCloseModal = () => {
    setOpenDeleteModalExp(false);
    setSelectedIndex(null); // Clear the selected index
  };

  const handleDeleteConfirm = async () => {
    if (selectedIndex === null) return;

    setDeleteLoadingExp(true);
    try {
      // Parse the work experience data if it's a string
      const workExperienceData =
        typeof experienceData === "string"
          ? JSON.parse(experienceData)
          : experienceData;

      // Filter out the experience at the selected index from the work_experience array
      const filteredArray = workExperienceData.work_experience.filter(
        (_, index) => index !== selectedIndex,
      );

      // Create a completely new object
      const newWorkExperience = {
        work_experience: filteredArray,
      };

      // Add numeric indices that match the filtered array
      filteredArray.forEach((exp, idx) => {
        newWorkExperience[idx.toString()] = exp;
      });

      // Immediately update the local state via the callback
      if (onUpdate) {
        onUpdate(newWorkExperience);
      }

      // Prepare payload for API call
      const payload = {
        baseId,
        applicationId: applicationId ? applicationId : applicationIdByParent,
        app_work: JSON.stringify(newWorkExperience),
      };

      // Call the API
      const response = await dispatch(
        UpdateJobApplicationByListForApplication(payload),
      ).unwrap();

      if (response.status === 200) {
        toast.success("Experience deleted successfully");
        setIsModalOpen(false);

        // Fetch updated application details
        const res = await dispatch(
          fetchApplicationByDetails({
            baseId: Number(baseId),
            jobId: jobId,
            applicationId: applicationId
              ? applicationId
              : applicationIdByParent,
          }),
        ).unwrap();

        if (res.status === 200) {
          setapplicationDetails(res?.data);
        }

        // Close the modal
        setOpenDeleteModalExp(false);
        setSelectedIndex(null);
      }
    } catch (error) {
      console.error("Failed to delete work experience:", error);
      // alert("Failed to delete experience. Please try again.");
      toast.error("Failed to delete experience. Please try again.");
    } finally {
      setDeleteLoadingExp(false);
    }
  };

  return (
    <>
      <div className="space-y-2 mx-[-12px]">
        {workExperience.work_experience?.map((work, index) => {
          const formattedDateRange = formatDateRange(work);
          if (!work) return null; // Skip null values
          return (
            <div
              key={index}
              className="flex gap-4 items-start hover:bg-gray-50 p-3 rounded-lg cursor-pointer transition-colors group"
              onClick={() => handleEditClick(work, index)}
            >
              <div className="w-9 h-9 flex-shrink-0">
                <div
                  className="w-full h-full rounded-lg flex items-center justify-center text-white font-medium"
                  style={{
                    backgroundColor: getColorForLabel(work?.company || ""),
                  }}
                >
                  {work?.company?.charAt(0)}
                </div>
              </div>

              <div className="flex-1">
                <h3 className="text-[14px] text-[#374151] font-medium leading-5">
                  {work?.designation}
                </h3>
                <p className="font-normal text-[#374151] text-[13px] wg-antialiased leading-5">
                  {work?.company}
                </p>

                <div className="mt-0 flex items-center gap-4 text-sm text-gray-500 flex-wrap lg:flex-nowrap">
                  {formattedDateRange && (
                    <div className="mt-0 flex items-center gap-4 text-gray-500">
                      <span className="font-normal text-dark-black-200 text-[13px]">
                        {formattedDateRange}
                      </span>
                    </div>
                  )}
                </div>

                <div className="flex items-center flex-wrap">
                  {work?.location && (
                    <div className="flex items-center gap-1">
                      <span className="font-normal text-dark-black-200 text-[13px] leading-5">
                        {work?.location}
                      </span>
                    </div>
                  )}
                  {work?.workplace_type && (
                    <div className="flex items-center gap-[6px]">
                      {work?.location && (
                        <span className="h-[3px] w-[3px] bg-gray-400 rounded-full block ml-[6px]"></span>
                      )}
                      <span className="ml-0 leading-5">
                        {" "}
                        <span className="text-dark-black-200  leading-5">
                          {work?.workplace_type}
                        </span>
                      </span>
                    </div>
                  )}
                </div>
                {work?.description && (
                  <div className="flex items-center gap-[6px]">
                    <span className="font-normal text-[#374151] text-[13px] wg-antialiased leading-5">
                      {work?.description}
                    </span>
                  </div>
                )}
              </div>

              {/* Edit Button - Visible on Hover */}
              {!isConductReview && (
                <div className="flex items-center gap-4 opacity-0 group-hover:opacity-100 transition-opacity">
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent the parent onClick from firing
                      handleEditClick(work, index);
                    }}
                    className="text-gray-500 hover:text-gray-900"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="icon icon-tabler icons-tabler-outline icon-tabler-edit w-[1rem] h-[1rem]"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                      <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                      <path d="M16 5l3 3" />
                    </svg>
                  </button>
                </div>
              )}
            </div>
          );
        })}
        <Dialog
          open={isModalOpen}
          onClose={setIsModalOpen}
          className="relative z-10"
        >
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500/35 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />

          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl
               transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300
                data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <h3 className="text-base font-semibold leading-6 text-gray-900">
                  Edit Experience Details
                </h3>
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    <span className="sr-only">Close</span>
                    <CrossIcon aria-hidden="true" className="size-6" />
                  </button>
                </div>
                <div className="grid gap-4 py-4 mt-1">
                  <div className="grid gap-[6px]">
                    <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                      Company <span className="text-red-500">*</span>
                    </label>
                    <input
                      name="company"
                      value={editForm.company}
                      onChange={handleInputChange}
                      className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                    />
                  </div>
                  <div className="grid gap-[6px]">
                    <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                      Designation <span className="text-red-500">*</span>
                    </label>
                    <input
                      name="designation"
                      value={editForm.designation}
                      onChange={handleInputChange}
                      className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors duration-100 placeholder:text-surface-500
                             outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 dark:hover:border-surface-200
                              border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                    />
                  </div>
                  <div className="grid grid-cols-2 gap-4">
                    <CustomDropdown
                      label="Start Month"
                      value={editForm.startDateMonth}
                      onChange={handleInputChange}
                      options={months}
                      name="startDateMonth"
                    />
                    <CustomDropdown
                      label="Start Year"
                      value={editForm.startDateYear}
                      onChange={handleInputChange}
                      options={years}
                      name="startDateYear"
                    />
                  </div>
                  <div className="grid gap-[6px] mt-[-10px]">
                    <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5 w-[100px]">
                      <input
                        type="checkbox"
                        name="isCurrentJob"
                        checked={editForm.isCurrentJob}
                        onChange={handleInputChange}
                        className="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:border-indigo-600 checked:bg-indigo-600 indeterminate:border-indigo-600 indeterminate:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                      />
                      Current Job
                    </label>
                  </div>

                  {!editForm.isCurrentJob && (
                    <div className="grid grid-cols-2 gap-4">
                      <CustomDropdown
                        label="End Month"
                        value={editForm.endDateMonth}
                        onChange={handleInputChange}
                        options={months}
                        name="endDateMonth"
                      />
                      <CustomDropdown
                        label="End Year"
                        value={editForm.endDateYear}
                        onChange={handleInputChange}
                        options={years}
                        name="endDateYear"
                      />
                    </div>
                  )}
                  <JobWorkplaceTypeListbox
                    value={workplaceType}
                    onChange={handleWorkplaceTypeChange}
                  />
                  <div className="grid gap-[6px]">
                    <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                      Location
                    </label>
                    <JobEduLocationModal
                      items={locations}
                      buttonText="Search by city, state, or country"
                      onChange={handleLocationChange}
                      selectedItem={selectedCountry}
                      isLoading={loadingLocation}
                    />
                    {/* <input
                    name="location"
                    value={editForm.location}
                    onChange={handleInputChange}
                    className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors duration-100 placeholder:text-surface-500 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 dark:hover:border-surface-200 border-surface-200 dark:border-surface-100 focus:outline-indigo-600 border-[#e5e7eb]"
                  /> */}
                  </div>
                  <div className="grid gap-[6px]">
                    <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                      Description
                    </label>
                    <textarea
                      id="description"
                      name="description"
                      rows={4}
                      onChange={handleInputChange}
                      className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6"
                      value={editForm.description}
                    />
                  </div>
                  {/* <div className="grid gap-[6px]">
                                    <label className="wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5">
                                        Workplace Type
                                    </label>
                                    <select
                                        name="workplaceType"
                                        value={editForm.workplaceType}
                                        onChange={handleInputChange}
                                        className="flex grow rounded-lg border bg-background px-4 py-[5px] text-sm leading-6 shadow-wg-xs transition-colors duration-100 outline-primary focus:outline focus:outline-1 focus:-outline-offset-1 w-full text-surface-900 hover:border-surface-300 border-surface-200 focus:outline-indigo-600 border-[#e5e7eb]"
                                    >
                                        <option value="">Select Type</option>
                                        <option value="On-site">On-site</option>
                                        <option value="Remote">Remote</option>
                                        <option value="Hybrid">Hybrid</option>
                                    </select>
                                </div> */}
                </div>

                <div className="flex justify-between gap-4 mt-5">
                  <div className="flex items-center gap-4">
                    <button
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation(); // Prevent the parent onClick from firing
                        handleDeleteClick(selectedEducation, selectedIndex); // Pass the entire experience object
                      }}
                      className="text-gray-500 hover:text-gray-900"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="icon icon-tabler icons-tabler-outline icon-tabler-trash w-[1rem] h-[1rem] text-[#808080]"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M4 7l16 0" />
                        <path d="M10 11l0 6" />
                        <path d="M14 11l0 6" />
                        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                        <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                      </svg>
                    </button>
                  </div>

                  <div className="flex justify-end gap-4">
                    <button
                      className="rounded-md bg-white items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                      onClick={() => setIsModalOpen(false)}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleSubmit}
                      className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      <div className="flex items-center gap-[6px]">
                        Save
                        {isLoading && (
                          <div className="simple-spinner">
                            <span></span>
                          </div>
                        )}
                      </div>
                    </button>
                  </div>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
      </div>

      {openDeleteModalExp && (
        <Dialog
          open={true}
          onClose={handleCloseModal}
          className="relative z-10"
        >
          <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
          />
          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <DialogPanel
                transition
                className="relative transform rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
              >
                <div className="absolute right-0 top-0 hidden pr-4 pt-4 sm:block">
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                  >
                    <span className="sr-only">Close</span>
                    <CrossIcon />
                  </button>
                </div>
                <div className="flex flex-col gay-y-4">
                  <span className="leading-6 text-sm text-gray-500">
                    Do you want to sure delete this Experience?
                  </span>
                </div>
                <div className="mt-5 sm:mt-4 flex gap-2 justify-end">
                  <button
                    type="button"
                    onClick={handleCloseModal}
                    className="items-center px-[14px] py-1 text-[13px] font-medium h-[32px] inline-flex leading-6 w-fit justify-center rounded-md bg-white  text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleDeleteConfirm}
                    type="button"
                    className="rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 "
                  >
                    {deleteLoadingExp ? (
                      <div className="flex items-center gap-[6px]">
                        Delete
                        <div className="simple-spinner">
                          <span></span>
                        </div>
                      </div>
                    ) : (
                      "Delete"
                    )}
                  </button>
                </div>
              </DialogPanel>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default JobExperienceSection;
